import { BaseService } from '@flint/framework';

export default class GetTopic extends BaseService {
  constructor() {
    super("FETCHING_TOPIC_DATA", 'TopicStore', true);
  }

  handleEvent(eventName, ID) {
    return this.getClient('vetService').get(`/admin-api/topics/${ID}/features`);
  }
}